package com.exura.features.publicplans.domain.api

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
@JsName("EnablePublicPlanSharingRequest")
data class EnablePublicPlanSharingRequest(
    @JsName("globalEntryId")
    val globalEntryId: String
)